import ScreenService from './screen-service';
import FormatService from './format-service';
import { TIMEOUT_MINIMAL } from '../constants/system/timeouts';

export default class CommentService {
  public static ID_COMMENT_SEND_BUTTON: string = 'comment-send-button';
  public static ID_COMMENT_CONTAINER: string = 'comment-container';
  public static ID_PREFIX_COMMENT_EDIT_BUTTON: string = 'comment-edit-button';
  public static ID_PREFIX_COMMENT_TABLE_ROW: string = 'comment-table-row';
  public static CLASS_NAME_COMMENT_TABLE_ROW: string = 'comment-table-row';

  private static HTML_ATTRIBUTE_ID: string = 'id';
  private static COMMENT_SCROLL_OFFSET: number = -30;

  public static editLastComment(): void {
    const commentTableRowList: HTMLCollection = ScreenService.getElementsByClassName(this.CLASS_NAME_COMMENT_TABLE_ROW);
    const lastCommentTableRow: Element = commentTableRowList[commentTableRowList.length - 1];
    const dataCommentId: string | null = lastCommentTableRow.getAttribute(this.HTML_ATTRIBUTE_ID)
      ?.replace(`${this.ID_PREFIX_COMMENT_TABLE_ROW}-`, '') || null;
    const editCommentButton: HTMLElement | null = dataCommentId ? ScreenService.getElementById(
      `${this.ID_PREFIX_COMMENT_EDIT_BUTTON}-${FormatService.parseInt(dataCommentId)}`,
    ) : null;

    if (editCommentButton) {
      setTimeout((): void => {
        editCommentButton.click();
      }, TIMEOUT_MINIMAL);
    }

    if (dataCommentId) {
      this.scrollToComment(FormatService.parseInt(dataCommentId));
    }
  }

  public static sendComment(): void {
    const commentSendButton: HTMLElement | null = ScreenService.getElementById(this.ID_COMMENT_SEND_BUTTON);

    if (commentSendButton) {
      setTimeout((): void => {
        commentSendButton.click();
      }, TIMEOUT_MINIMAL);
    }
  }

  public static scrollToComment(commentId: number): void {
    if (commentId) {
      setTimeout((): void => {
        ScreenService.scrollToElement(
          `${this.ID_PREFIX_COMMENT_TABLE_ROW}-${commentId}`,
          this.ID_COMMENT_CONTAINER,
          this.COMMENT_SCROLL_OFFSET,
        );
      }, TIMEOUT_MINIMAL);
    }
  }
}
